import React, { useEffect } from 'react';
import '../styles/ImageModal.css';

const ImageModal = ({ imageUrl, onClose }) => {
  // Close the modal when Escape key is pressed
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    
    // Prevent scrolling on the body when modal is open
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'auto';
    };
  }, [onClose]);

  // Close modal when clicking outside the image
  const handleBackdropClick = (e) => {
    if (e.target.classList.contains('image-modal-backdrop')) {
      onClose();
    }
  };

  return (
    <div className="image-modal-backdrop" onClick={handleBackdropClick}>
      <div className="image-modal-content">
        <button className="image-modal-close" onClick={onClose}>×</button>
        <img 
          src={imageUrl} 
          alt="Enlarged view" 
          className="image-modal-image" 
        />
      </div>
    </div>
  );
};

export default ImageModal;